import { Controller } from "stimulus";
import Turbolinks from "turbolinks";

export default class extends Controller {
  static targets = ["filterForm", "clearButton", "expandButton", "submitButton"];

  connect() {
    // make sure the filters work without JS in case we mess up again

    if (this.element.id === "shipments-tasks-filters") {
      this.expandButtonTarget.hidden = true;
    } else {
      this.expandButtonTarget.hidden = false;
    }

    this.submitButtonTarget.hidden = true;
    this.filterFormTarget.classList.add("expandable");

    delete this.element.dataset.turbolinksPermanent;

    for (const element of this.filterFormTarget.elements) {
      element.readonly = false;
      $(element).on("change", (event) => this.submit(event));
    }
  }

  clear() {
    delete this.element.dataset.turbolinksPermanent;
  }

  submit(event) {
    if (event.target.classList.contains("select2-search__field")) return;

    const form = this.filterFormTarget;
    const data = new FormData(form);
    const params = new URLSearchParams();

    for (const element of form.elements) {
      element.readonly = true;
    }

    for (const [key, value] of data) {
      if (value) {
        params.append(key, value);
      }
    }

    // only persist filters when changing a filter directly
    // not because of some other click on this page
    this.element.dataset.turbolinksPermanent = true;
    Turbolinks.visit(location.pathname + "?" + params.toString());
  }

  expand() {
    this.filterFormTarget.classList.toggle("expanded");

    if (this.expandButtonTarget.classList.toggle("active")) {
      this.expandButtonTarget.textContent = "Less filters";
    } else {
      this.expandButtonTarget.textContent = "More filters";
    }
  }
}
